// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/components/order-claims/warning-label/warning-label.less
// module id = 2990
// module chunks = 0 1